import { inject, Injectable } from '@angular/core';
import { Action, State, StateContext, StateToken, Store } from '@ngxs/store';
import { AuthActions } from '@shared/store/auth.actions';
import { EntityState } from '@shared/store/entity.state';
import { StoreActions } from '@shared/store/store.actions';

import { LoginApiService } from '../services/login-api.service';
import { LoginActions } from './login.actions';
import { mergeMap, of } from 'rxjs';
import { AppActions } from '../../app.actions';

export interface LoginStateModel {
  isLoaded: boolean;
  hasError: boolean;
}

export const LOGIN_STATE_TOKEN =
    new StateToken<LoginStateModel>('LoginState');

const defaultState: LoginStateModel = {
  isLoaded: false,
  hasError: false,
};

@State<LoginStateModel>({
  name: LOGIN_STATE_TOKEN,
  defaults: defaultState,
})
@Injectable()
export class LoginState {

  private _loginService = inject(LoginApiService);
  private _store = inject(Store);

  @Action(LoginActions.Login)
  login(
      ctx: StateContext<LoginStateModel>,
      action: LoginActions.Login,
  ) {
    return this._loginService
               .login$(action.payload)
               .pipe(
                   mergeMap((response) => {
                     if (!response) {
                       return of();
                     }
                     ctx.patchState(EntityState.getApiLoadSuccessConfig());
                     return this._store.dispatch(new AppActions.SetToken(response.token));
                   }),
               );
  }

  @Action(LoginActions.LoginFailed)
  requestFailed(ctx: StateContext<LoginStateModel>) {
    ctx.patchState(EntityState.getApiLoadErrorConfig());
  }

  @Action([
    StoreActions.ResetLoadedState,
    LoginActions.ResetLoadedState,
  ])
  resetLoadedState(ctx: StateContext<LoginStateModel>) {
    ctx.patchState({
      isLoaded: defaultState.isLoaded,
      hasError: defaultState.hasError,
    });
  }

  @Action([
    LoginActions.ResetState,
    StoreActions.ResetStore,
    AuthActions.Unauthorized,
  ])
  resetState(ctx: StateContext<LoginStateModel>) {
    ctx.setState({
      ...defaultState,
    });
  }
}
